const t = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
export {
  t as tzPattern
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/_lib/tzPattern/index.js
// module id = 1375
// module chunks = 67